// 专家义诊
// 所有page请放在 /user/page/freeClinic目录下
const FreeClinicIndex = () => import('../page/freeClinic/index/index.page');
const ConsultDetail = () => import('../page/freeClinic/consultDetail/index.page');
const MyConsult = () => import('../page/freeClinic/myConsult/index.page');
const FreeQuestion = () => import('../page/freeClinic/freeQuestion/index.page');

export default [
  {
    path: '/freeClinic/index',
    name: 'FreeClinicIndex',
    meta: {
      pageTitle: '专家答',
      requiresAuth: false        // 是否需要登录
    },
    component: FreeClinicIndex
  },

  {
    path: '/freeClinic/consultDetail',
    name: 'consultDetail',
    meta: {
      pageTitle: '专家答',
      requiresAuth: false        // 是否需要登录
    },
    component: ConsultDetail
  },

  {
    path: '/freeClinic/freeQuestion/:expertId/:actId',
    name: 'FreeQuestion',
    meta: {
      pageTitle: '问题描述',
      requiresAuth: true,
      authType: 'user'      // 是否需要登录
    },
    component: FreeQuestion
  },

  {
    path: '/freeClinic/myRequestion',
    name: 'myRequestion',
    meta: {
      pageTitle: '我的提问',
      requiresAuth: false
    },
    component: MyConsult
  }
];



// WEBPACK FOOTER //
// ./src/user/router/freeClinic.js